import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "pagination" }, null, -1)

import { useSlots, ref, onMounted, Ref } from 'vue'
import Flicking from '@egjs/vue3-flicking'
import '@egjs/vue3-flicking/dist/flicking.css'
import { Pagination } from '@egjs/flicking-plugins'


export default /*#__PURE__*/_defineComponent({
  __name: 'Carousel',
  emits: ['touchstart', 'touchend', 'slidechanged'],
  setup(__props, { emit: __emit }) {

const emit = __emit
const slots = useSlots()
const showPagination = ref(true)
const plugins: Ref<Pagination[]> = ref([])

onMounted(() => {
    // Hide pagination bullets if there is only one item in carousel
    if (slots.default && slots.default()[0]['children']) {
        const hasMultipleCarouselItems =
            Number(slots.default()[0]['children']?.length) > 1
        showPagination.value = hasMultipleCarouselItems

        if (hasMultipleCarouselItems) {
            plugins.value = [
                new Pagination({
                    type: 'bullet',
                    selector: '.pagination',
                    classPrefix: 'pagination',
                }),
            ]
        }
    }
})

const onTouchStart = () => {
    emit('touchstart')
}

const onTouchEnd = () => {
    emit('touchend')
}

const beforeChange = (event: { currentTarget: Flicking; index }) => {
    emit('slidechanged', event.currentTarget.index, event.index)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "carousel",
    onTouchstart: onTouchStart,
    onTouchend: onTouchEnd
  }, [
    _createVNode(_unref(Flicking), {
      options: { circular: true },
      plugins: plugins.value,
      onWillChange: beforeChange
    }, _createSlots({
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default")
      ], undefined, true),
      _: 2
    }, [
      (showPagination.value)
        ? {
            name: "viewport",
            fn: _withCtx(() => [
              _hoisted_1
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["plugins"])
  ], 32))
}
}

})